__turbopack_context__.v({
  "press": "SettingList-module-scss-module__1XzwFq__press",
  "wrap": "SettingList-module-scss-module__1XzwFq__wrap",
});
